import request from "@/utils/request";

export const url = {
  GetDishList: "/api/Restaurant/GetDishList", //获取菜品清单
  OrderDish: "/api/Restaurant/OrderDish", //点菜
  RMS_GetTableStatus: "/api/Restaurant/GetTableStatus", //餐饮，获取桌台数据
  RMS_CreateOrder: "/api/Restaurant/CreateOrder", // 提交开台
  ChangeMarket: "/api/Auth/ChangeMarket", //切换分市
  RMS_CleanTable: "/api/Restaurant/CleanTable", //清洁桌台
  // Rest_GetOrderDetail: "/api/Restaurant/GetOrderDetail", //查询订单详情
  ReturnDish: "/api/Restaurant/ReturnDish", //退菜
  RMS_EditPriceAsync: "/api/Restaurant/EditPrice", //改价
  Rest_CancelOrder: "/api/Restaurant/CancelOrder", //取消订单
  RMS_ChangeTable: "/api/Restaurant/ChangeTable", //换台
  RMS_Settle: "/api/Restaurant/Settle", //结账
  GetAppointRoomInfo: "/api/Breakfast/GetAppointRoomInfo", //获取在住的房间
  RMS_Discount: "/api/Restaurant/Discount", //打折
  GetRestaurantConfig: "/api/MobileRestaurant/GetRestaurantConfig",
  FreeRemnant: "/api/Restaurant/FreeRemnant", //抹零
  CancelFreeRemnant: "/api/Restaurant/CancelFreeRemnant",
  GetOrderPageAsync: "/api/Restaurant/GetOrderPage", //查询订单分页
  RMS_AntiSettle: "/api/Restaurant/AntiSettle", //反结
};
function sendRequest(apiUrl, params, type, opt = {}) {
  return request({
    ...opt,
    url: apiUrl,
    method: type,
    data: params,
  });
}

export default class restaurantManageApi {
  static antiSettle(params, type = "post") {
    return sendRequest(url.RMS_AntiSettle, params, type);
  }

  static getOrderPageAsync(params, type = "post") {
    return sendRequest(url.GetOrderPageAsync, params, type);
  }

  static freeRemnant(params, type = "post") {
    return sendRequest(url.FreeRemnant, params, type);
  }
  static cancelFreeRemnant(params, type = "post") {
    return sendRequest(url.CancelFreeRemnant, params, type);
  }

  static getRestaurantConfig(params, type = "post") {
    return sendRequest(url.GetRestaurantConfig, params, type);
  }
  static discount(params, type = "post") {
    return sendRequest(url.RMS_Discount, params, type);
  }
  static getAppointRoomInfo(params, type = "post") {
    return sendRequest(url.GetAppointRoomInfo, params, type);
  }
  static settle(params, type = "post") {
    return sendRequest(url.RMS_Settle, params, type);
  }
  static changeTable(params, type = "post") {
    return sendRequest(url.RMS_ChangeTable, params, type);
  }
  static cancelOrder(params, type = "post") {
    return sendRequest(url.Rest_CancelOrder, params, type);
  }
  static returnDish(params, type = "post") {
    return sendRequest(url.ReturnDish, params, type);
  }
  static editPrice(params, type = "post") {
    return sendRequest(url.RMS_EditPriceAsync, params, type);
  }
  // static getOrderDetail(params, type = "post") {
  //   return sendRequest(url.Rest_GetOrderDetail, params, type);
  // }
  static cleanTable(params, type = "post") {
    return sendRequest(url.RMS_CleanTable, params, type);
  }
  static getDishList(params, type = "post") {
    return sendRequest(url.GetDishList, params, type);
  }
  static orderDish(params, type = "post") {
    return sendRequest(url.OrderDish, params, type);
  }
  static changeMarket(params, type = "post") {
    return sendRequest(url.ChangeMarket, params, type);
  }

  static getTableStatus(params, type = "post") {
    return sendRequest(url.RMS_GetTableStatus, params, type);
  }
  static createOrder(params, type = "post") {
    return sendRequest(url.RMS_CreateOrder, params, type);
  }
}
